/**
 * Runs type guard check for LevelAttribute.
 *
 * @param arg - object to check
 * @internal
 */
export function isLevelAttribute(arg) {
    return 'granularity' in arg;
}
/**
 * Runs type guard check for PivotAttribute.
 *
 * @param arg - object to check
 * @internal
 */
export function isPivotAttribute(arg) {
    return 'attribute' in arg;
}
/**
 * Runs type guard check for PivotMeasure.
 *
 * @param arg - object to check
 * @internal
 */
export function isPivotMeasure(arg) {
    return 'measure' in arg;
}
/**
 * @internal
 */
export const DEFAULT_PIVOT_GRAND_TOTALS = {
    rows: false,
    columns: false,
};
//# sourceMappingURL=interfaces.js.map